
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns10b5454addbf143cc78198537a6ccc0aen from './en.yaml'
            i18n.addResourceBundle('en', '10b5454addbf143cc78198537a6ccc0a', flattenObject(ns10b5454addbf143cc78198537a6ccc0aen), true, true);
        
        export default '10b5454addbf143cc78198537a6ccc0a';
    